<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">案卷信息</div>
    </div>

    <div class="modul-content">
      <el-tabs v-model="radio" @tab-click="handleClick">
        <el-tab-pane label="新增" name="1"></el-tab-pane>
        <el-tab-pane label="已完成" name="2"></el-tab-pane>
        <el-tab-pane label="已复位" name="3"></el-tab-pane>
      </el-tabs>
      <!-- 查询 -->
      <div class="query-form">
        <el-form :inline="true" :model="form" ref="form">
          <el-form-item label="桥梁名称" prop="equipmentTypeName">
            <el-input
              v-model="form.equipmentTypeName"
              clearable
              placeholder="请输入台账名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker
              v-model="time"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="tableReq(1)">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- <el-form :inline="true">
         <el-form-item>
            <el-button 
                       @click="addVisible = true;isequipmentTypeUpdate = false;">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button 
                       @click="onExport">导出</el-button>
          </el-form-item>
        </el-form> -->
      </div>
      <div class="tableStyles" v-if="radio == '1'">
        <div
          class="tableItemStyle"
          v-for="(item, index) in tableData"
          :key="index"
        >
          <div
            class="tableItemImg"
            style="position: relative; margin-right: 10px"
          >
            <el-carousel style="width: 100%; height: 100%">
              <el-carousel-item
                v-for="items in item.reportPicture"
                :key="items"
                style="width: 100%; height: 100%"
              >
                <el-image
                  :src="items"
                  :preview-src-list="[items]"
                  style="width: 100%; height: 100%"
                >
                </el-image>
                <!-- <img :src="items" alt="" style="width: 100%;height: 100%;"> -->
              </el-carousel-item>
            </el-carousel>
            <div>处理前</div>
          </div>
          <div class="tableItemText">
            <p>ID：{{ item.reportUuid }}</p>
            <p>上报人：{{ item.reportPeopleName }}</p>
          </div>
          <div class="tableItemText">
            <p>设施：{{ item.bridgeName }}</p>
            <p>上报时间：{{ item.reportTime }}</p>
          </div>
          <div class="tableItemText">
            <p>
              问题类型：{{
                item.problemType == 0
                  ? '隔离栏'
                  : item.problemType == 1
                  ? '其他'
                  : item.problemType == 2
                  ? '护栏'
                  : item.problemType == 3
                  ? '桥梁'
                  : item.problemType == 4
                  ? '树围'
                  : item.problemType == 5
                  ? '井盖'
                  : item.problemType == 6
                  ? '沥青路面'
                  : item.problemType == 7
                  ? '道板'
                  : item.problemType == 8
                  ? '砼路面'
                  : item.problemType == 9
                  ? '石墩'
                  : item.problemType == 10
                  ? '缘石坡道'
                  : item.problemType == 11
                  ? '道路积水'
                  : item.problemType == 12
                  ? '花坛'
                  : item.problemType == 13
                  ? '道路开挖'
                  : '未填写类型'
              }}
            </p>
            <p>案卷描述：{{ item.caseDescribe }}</p>
          </div>
          <div class="tableItemText">
            <p>位置描述：{{ item.locationdDescribe }}</p>
          </div>
        </div>
      </div>
      <div class="tableStyles" v-else-if="radio == '2'">
        <div
          class="tableItemStyle"
          v-for="(item, index) in tableData"
          :key="index"
        >
          <div
            class="tableItemImg"
            style="position: relative; margin-right: 10px"
          >
            <el-carousel style="width: 100%; height: 100%">
              <el-carousel-item
                v-for="items in item.reportPicture"
                :key="items"
                style="width: 100%; height: 100%"
              >
                <el-image
                  :src="items"
                  :preview-src-list="[items]"
                  style="width: 100%; height: 100%"
                >
                </el-image>
                <!-- <img :src="items" alt="" style="width: 100%;height: 100%;"> -->
              </el-carousel-item>
            </el-carousel>
            <div>处理前</div>
          </div>
          <div
            class="tableItemImg"
            style="position: relative; margin-right: 10px"
          >
            <el-carousel style="width: 100%; height: 100%">
              <el-carousel-item
                v-for="items in item.reportAfterPicture"
                :key="items"
                style="width: 100%; height: 100%"
              >
                <el-image
                  :src="items"
                  :preview-src-list="[items]"
                  style="width: 100%; height: 100%"
                >
                </el-image>
                <!-- <img :src="items" alt="" style="width: 100%;height: 100%;"> -->
              </el-carousel-item>
            </el-carousel>
            <!-- <img :src="item.reportAfterPicture[0]" alt=""> -->
            <div>处理后</div>
          </div>
          <div class="tableItemText">
            <p>ID：{{ item.reportUuid }}</p>
            <p>上报人：{{ item.reportPeopleName }}</p>
            <p>案卷描述：{{ item.caseDescribe }}</p>
            <p>处理意见：{{ item.disposeOpinion }}</p>
            <p>上报工程量：{{ item.reportWorkAmount }}</p>
          </div>
          <div class="tableItemText">
            <p>设施：{{ item.bridgeName }}</p>
            <p>上报时间：{{ item.reportTime }}</p>
            <p>执行人：{{ item.executePeopleName }}</p>
            <p>备注：{{ item.remark }}</p>
            <p>处理时间：{{ item.processingTime }}</p>
            <p>执行单位：{{ item.executeUnit }}</p>
          </div>
          <div class="tableItemText">
            <p>
              问题类型：{{
                item.problemType == 0
                  ? '隔离栏'
                  : item.problemType == 1
                  ? '其他'
                  : item.problemType == 2
                  ? '护栏'
                  : item.problemType == 3
                  ? '桥梁'
                  : item.problemType == 4
                  ? '树围'
                  : item.problemType == 5
                  ? '井盖'
                  : item.problemType == 6
                  ? '沥青路面'
                  : item.problemType == 7
                  ? '道板'
                  : item.problemType == 8
                  ? '砼路面'
                  : item.problemType == 9
                  ? '石墩'
                  : item.problemType == 10
                  ? '缘石坡道'
                  : item.problemType == 11
                  ? '道路积水'
                  : item.problemType == 12
                  ? '花坛'
                  : item.problemType == 13
                  ? '道路开挖'
                  : '未填写类型'
              }}
            </p>
            <p>建设单位：{{ item.constructionUnit }}</p>
            <p>建设单位意见：{{ item.constructionUnitOpinion }}</p>
            <p>建设审核时间：{{ item.constructionTime }}</p>
            <p>
              建设单位签字：<img :src="item.constructionUnitPepole" alt="" />
            </p>
            <p>施工单位签字：<img :src="item.buildPeople" alt="" /></p>
          </div>
          <div class="tableItemText">
            <p>位置描述：{{ item.locationdDescribe }}</p>
            <p>监理单位：{{ item.supervisorUnit }}</p>
            <p>监理单位意见：{{ item.supervisorUnitOpinion }}</p>
            <p>监理单位审核时间：{{ item.supervisorTime }}</p>
            <p>监理单位签字：<img :src="item.supervisorUnitPeople" alt="" /></p>
          </div>
        </div>
      </div>
      <div class="tableStyles" v-else>
        <div
          class="tableItemStyle"
          v-for="(item, index) in tableData"
          :key="index"
        >
          <div
            class="tableItemImg"
            style="position: relative; margin-right: 10px"
          >
            <el-carousel style="width: 100%; height: 100%">
              <el-carousel-item
                v-for="items in item.reportPicture"
                :key="items"
                style="width: 100%; height: 100%"
              >
                <el-image
                  :src="items"
                  :preview-src-list="[items]"
                  style="width: 100%; height: 100%"
                >
                </el-image>
                <!-- <img :src="items" alt="" style="width: 100%;height: 100%;"> -->
              </el-carousel-item>
            </el-carousel>
            <div>处理前</div>
          </div>
          <div class="tableItemText">
            <p>ID：{{ item.reportUuid }}</p>
            <p>上报人：{{ item.reportPeopleName }}</p>
            <p>复位原因：{{ item.restorationReason }}</p>
          </div>
          <div class="tableItemText">
            <p>设施：{{ item.bridgeName }}</p>
            <p>上报时间：{{ item.reportTime }}</p>
            <p>复位时间：{{ item.restorationTime }}</p>
          </div>
          <div class="tableItemText">
            <p>
              问题类型:{{
                item.problemType == 0
                  ? '隔离栏'
                  : item.problemType == 1
                  ? '其他'
                  : item.problemType == 2
                  ? '护栏'
                  : item.problemType == 3
                  ? '桥梁'
                  : item.problemType == 4
                  ? '树围'
                  : item.problemType == 5
                  ? '井盖'
                  : item.problemType == 6
                  ? '沥青路面'
                  : item.problemType == 7
                  ? '道板'
                  : item.problemType == 8
                  ? '砼路面'
                  : item.problemType == 9
                  ? '石墩'
                  : item.problemType == 10
                  ? '缘石坡道'
                  : item.problemType == 11
                  ? '道路积水'
                  : item.problemType == 12
                  ? '花坛'
                  : item.problemType == 13
                  ? '道路开挖'
                  : '未填写类型'
              }}
            </p>
            <p>案卷描述:{{ item.caseDescribe }}</p>
          </div>
          <div class="tableItemText">
            <p>位置描述:{{ item.locationdDescribe }}</p>
            <p>复位人:{{ item.restorationPeople }}</p>
          </div>
        </div>
      </div>
      <!-- <el-table class="tableStyle"
                v-loading="loading"
                height="calc(100vh - 350px)"
                border
                style="width: 100%"
                :data="tableData"
                :header-cell-style="{background:'#FAFAFA',color:'#000000'}">
        <el-table-column label="序号"
                         align="center"
                         type="index"
                         width="50px"></el-table-column>
        <el-table-column prop="name"
                         label="桥梁名称"
                         align="center"></el-table-column>
        <el-table-column prop="name1"
                         label="编号"
                         align="center"></el-table-column>
        <el-table-column prop="name2"
                         label="病害内容"
                         align="center"></el-table-column>
        <el-table-column prop="name3"
                         label="上报时间"
                         align="center"></el-table-column>
        <el-table-column prop="name4"
                         label="上报人"
                         align="center"></el-table-column>
        <el-table-column prop="name5"
                         label="病害图片"
                         align="center">
          <template #default='scope'>
            <div v-if="scope.row.name5">
              <el-image class="table-img"
                        :src="scope.row.name5.split(',')[0]"
                        :preview-src-list="scope.row.name5.split(',')"
                        alt="设施照片">
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name6"
                         label="修复图片"
                         align="center">
          <template #default='scope'>
            <div v-if="scope.row.name6">
              <el-image class="table-img"
                        :src="scope.row.name6.split(',')[0]"
                        :preview-src-list="scope.row.name6.split(',')"
                        alt="设施照片">
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name7"
                         label="完成人"
                         align="center"></el-table-column>
        <el-table-column prop="name8"
                         label="完成时间"
                         align="center"></el-table-column>
        <el-table-column prop="name9"
                         label="状态"
                         align="center">
          <template #default='scope'>
            {{scope.row.name9==0?'处理中':scope.row.name9==1?'退回':scope.row.name9==2?'已上报':scope.row.name9==3?'已完成':'状态不明'}}
          </template>
        </el-table-column>
      </el-table> -->
      <!--  -->
      <div style="text-align: center; margin: 20px 0 0">
        <el-pagination
          @size-change="handleSizeChange"
          :hide-on-single-page="!total"
          @current-change="handleCurrentChange"
          :current-page="form.pageNum"
          :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]"
          :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeqingBridgeAndTunnelAnjuanxinxi',

  data() {
    return {
      form: {
        endTime: '',
        startTime: '',
        pageNum: 1,
        pageSize: 10
      },
      time: [],
      loading: false,
      tableData: [],
      total: 0,
      FormData: {},
      radio: '1'
    }
  },

  mounted() {
    this.tableReq()
  },

  methods: {
    //tab切换
    handleClick(one, two) {
      // console.log(one.index);
      // this.form.state=Number(one.index)
      console.log(one, two)
      this.tableReq()
    },
    //获取数据
    async tableReq(page) {
      this.loading = true
      this.tableData = []
      if (page) {
        this.form.pageNum = page
      }
      let data = {
        ...this.form
      }
      if (this.radio == '1' || this.radio == '2') {
        data.flag = Number(this.radio)
      } else {
        data.hasReset = 1
      }
      console.log(data)
      const res = await this.$api.sendPost('/report/getReport', data)
      this.loading = false
      console.log(res)
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.tableData = res.data.list
          this.tableData.forEach((i) => {
            i.reportPicture = i.reportPicture
              ? i.reportPicture.split(',')
              : null
            i.reportAfterPicture = i.reportAfterPicture
              ? i.reportAfterPicture.split(',')
              : []
          })
          // this.tableData=[{reportPicture:1,reportPeopleName:2,reportUuid:3,problemType:4}]
          this.total = res.data.total
        } else {
          this.tableData = []
          // this.total=0;
        }
        console.log(this.tableData)
      }
    },
    //时间选择
    timeChange(e) {
      console.log(e)
      let time = JSON.parse(JSON.stringify(e))
      console.log(time)
      if (time != undefined && time.length > 0) {
        this.form.startTime = time[0]
        this.form.endTime = time[1]
      } else {
        this.form.startTime = ''
        this.form.endTime = ''
      }
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.form.pageSize = val
      this.tableReq(1)
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.form.pageNum = val
      this.tableReq()
    },
    onExport() {},
    //新增和修改案卷
    async anjuanAdd(data) {
      if (data.id != undefined) {
        this.FormData = data
        const res = await this.$api.sendPost(
          '/report/insertReport',
          this.FormData
        )
        this.tableReq()
      } else {
        const res = await this.$api.sendPost(
          '/report/insertReport',
          this.FormData
        )
        this.tableReq()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.tableStyles {
  height: 600px;
  overflow: scroll;

  .tableItemStyle {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    padding: 15px 0;
    text-align: left;

    > .tableItemText {
      flex: 1;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      font-size: 14px;

      // justify-content: space-between;
      p {
        margin-bottom: 10px;
      }

      img {
        width: 60px;
        height: 20px;
      }
    }

    .tableItemImg {
      width: 200px;
      height: 200px;

      img {
        width: 200px;
        height: 200px;
      }

      > div {
        position: absolute;
        color: #fff;
        background: rgba(0, 0, 0, 0.3);
        bottom: 0;
        width: 200px;
        left: 0;
        text-align: center;
        padding: 3px 0;
      }
    }
  }
}
</style>
